<mat-toolbar color="primary">
  <span id="spørreundersøkelse-rediger-dialog-tittel">
    {{ "Rediger spørreundersøkelse"|translate }}
  </span>
  <button mat-icon-button aria-label="Lukk dialog" (click)="avbryt()">
    <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
  </button>
</mat-toolbar>

<form [formGroup]="skjema" (ngSubmit)="lagre()">
  <mat-dialog-content>
    <spoerreundersoekelse-skjema [skjemakontroll]="skjema" [tilgjengeligeSkjema]="tilgjengeligeSkjema()"/>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    @if (undersoekelseSkjemaKomp().erFoersteSteg()) {
      <button mat-button type="button" (click)="avbryt()">{{ "Avbryt"|translate }}</button>
    } @else {
      <button mat-button type="button" (click)="undersoekelseSkjemaKomp().forrigeSteg()">{{ "Forrige"|translate }}</button>
    }
    @if (undersoekelseSkjemaKomp().erSisteSteg())  {
      <submit-button [arbeidPaagaar]="lagrer()" [skjema]="skjema" spinnerTekst="{{'Lagrer...'|translate}}">{{ 'Lagre'|translate }}</submit-button>
    } @else {
      <button mat-flat-button
              color="primary"
              type="button"
              (click)="undersoekelseSkjemaKomp().nesteSteg()"
              [disabled]="!undersoekelseSkjemaKomp().erSkjemaForAktivtStegGyldig()">
        {{ "Neste"|translate }}
      </button>
    }
  </mat-dialog-actions>
</form>
